// Configuration centralisée des statuts en français

// Statuts des tâches
export const TASK_STATUS = {
  todo: { label: 'À faire', color: 'bg-gray-100 text-gray-700', icon: 'Clock' },
  pending: { label: 'En attente', color: 'bg-gray-100 text-gray-700', icon: 'Clock' },
  in_progress: { label: 'En cours', color: 'bg-blue-100 text-blue-700', icon: 'Timer' },
  review: { label: 'En révision', color: 'bg-orange-100 text-orange-700', icon: 'AlertCircle' },
  awaiting_client: { label: 'À valider (client)', color: 'bg-amber-100 text-amber-700', icon: 'AlertCircle' },
  awaiting_validation: { label: 'À valider', color: 'bg-amber-100 text-amber-700', icon: 'AlertCircle' },
  completed: { label: 'Terminée', color: 'bg-green-100 text-green-700', icon: 'CheckCircle2' },
  done: { label: 'Terminée', color: 'bg-green-100 text-green-700', icon: 'CheckCircle2' },
  validated: { label: 'Validée', color: 'bg-emerald-100 text-emerald-700', icon: 'CheckCircle2' },
  cancelled: { label: 'Annulée', color: 'bg-red-100 text-red-700', icon: 'XCircle' }
};

// Statuts des projets
export const PROJECT_STATUS = {
  draft: { label: 'Brouillon', color: 'bg-gray-100 text-gray-700' },
  pending_brief: { label: 'Brief en attente', color: 'bg-amber-100 text-amber-700' },
  brief_sent: { label: 'Brief envoyé', color: 'bg-blue-100 text-blue-700' },
  active: { label: 'En cours', color: 'bg-blue-100 text-blue-700' },
  in_progress: { label: 'En cours', color: 'bg-blue-100 text-blue-700' },
  review: { label: 'En révision', color: 'bg-orange-100 text-orange-700' },
  completed: { label: 'Terminé', color: 'bg-green-100 text-green-700' },
  delivered: { label: 'Livré', color: 'bg-emerald-100 text-emerald-700' },
  cancelled: { label: 'Annulé', color: 'bg-red-100 text-red-700' },
  on_hold: { label: 'En pause', color: 'bg-yellow-100 text-yellow-700' }
};

// Statuts des tickets
export const TICKET_STATUS = {
  open: { label: 'Ouvert', color: 'bg-blue-100 text-blue-700' },
  in_progress: { label: 'En cours', color: 'bg-amber-100 text-amber-700' },
  waiting_client: { label: 'Attente client', color: 'bg-purple-100 text-purple-700' },
  resolved: { label: 'Résolu', color: 'bg-green-100 text-green-700' },
  closed: { label: 'Fermé', color: 'bg-gray-100 text-gray-700' }
};

// Priorités
export const PRIORITY_CONFIG = {
  low: { label: 'Basse', color: 'bg-gray-100 text-gray-600' },
  medium: { label: 'Moyenne', color: 'bg-yellow-100 text-yellow-700' },
  high: { label: 'Haute', color: 'bg-orange-100 text-orange-700' },
  urgent: { label: 'Urgente', color: 'bg-red-100 text-red-700' }
};

// Fonction utilitaire pour obtenir le label d'un statut
export const getTaskStatusLabel = (status) => {
  return TASK_STATUS[status]?.label || status;
};

export const getProjectStatusLabel = (status) => {
  return PROJECT_STATUS[status]?.label || status;
};

export const getTicketStatusLabel = (status) => {
  return TICKET_STATUS[status]?.label || status;
};

export const getPriorityLabel = (priority) => {
  return PRIORITY_CONFIG[priority]?.label || priority;
};

// Fonction générique pour traduire n'importe quel statut
export const getStatusLabel = (status) => {
  // Chercher dans tous les dictionnaires de statuts
  if (PROJECT_STATUS[status]) return PROJECT_STATUS[status].label;
  if (TASK_STATUS[status]) return TASK_STATUS[status].label;
  if (TICKET_STATUS[status]) return TICKET_STATUS[status].label;
  
  // Fallback pour les statuts non mappés
  const fallbackLabels = {
    'active': 'En cours',
    'pending': 'En attente',
    'in_progress': 'En cours',
    'completed': 'Terminé',
    'cancelled': 'Annulé',
    'approved': 'Approuvé',
    'rejected': 'Rejeté',
    'sent': 'Envoyé',
    'paid': 'Payé',
    'overdue': 'En retard',
    'scheduled': 'Planifié',
    'done': 'Terminé',
    'validated': 'Validé',
    'delivered': 'Livré',
    'draft': 'Brouillon',
    'open': 'Ouvert',
    'closed': 'Fermé',
    'resolved': 'Résolu',
    'waiting': 'En attente',
    'estimated': 'Estimé',
    'converted': 'Converti'
  };
  
  return fallbackLabels[status] || status;
};

// Fonction pour obtenir le badge de statut avec couleur
export const getStatusBadgeProps = (status) => {
  const allStatuses = { ...PROJECT_STATUS, ...TASK_STATUS, ...TICKET_STATUS };
  const config = allStatuses[status];
  
  if (config) {
    return { label: config.label, className: config.color };
  }
  
  // Fallback colors
  const fallbackColors = {
    'active': 'bg-blue-100 text-blue-700',
    'pending': 'bg-amber-100 text-amber-700',
    'approved': 'bg-green-100 text-green-700',
    'rejected': 'bg-red-100 text-red-700',
    'paid': 'bg-emerald-100 text-emerald-700',
    'sent': 'bg-blue-100 text-blue-700',
    'overdue': 'bg-red-100 text-red-700',
    'estimated': 'bg-purple-100 text-purple-700',
    'converted': 'bg-green-100 text-green-700'
  };
  
  return {
    label: getStatusLabel(status),
    className: fallbackColors[status] || 'bg-gray-100 text-gray-700'
  };
};
